import { Component, computed, input } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { plainToClass } from 'class-transformer';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-question-preview',
  templateUrl: 'question-preview.component.html',
  styleUrls: ['./question-preview.component.scss']
})
export class QuestionPreviewComponent {
  activeQuestion = input<Question>();

  question$ = computed(() => {
    if (!!this.activeQuestion()) {
      const question = plainToClass(Question, this.activeQuestion());
      question.cards?.forEach((card) => (card.visible = true));
      question.options?.forEach((option) => (option.visible = true));
      return question;
    }
  });

  dummyControl$ = computed(() => {
    if (!!this.activeQuestion()) {
      return this.mapDummyControl(this.activeQuestion());
    }
  });

  private mapDummyControl(activeQuestion: Question): FormControl | FormArray | FormGroup {
    switch (activeQuestion.type) {
      case QuestionType.Carousel:
        return this.mapCarouselDummyControls(activeQuestion);
      case QuestionType.CarouselMultiChoice:
        return this.mapCarouselDummyControls(activeQuestion);
      case QuestionType.CarouselRating:
        return this.mapCarouselDummyControls(activeQuestion);
      case QuestionType.Dropdown:
      case QuestionType.MultiChoice:
      case QuestionType.Rating:
      case QuestionType.SingleChoice:
      case QuestionType.RankSort:
        return this.mapChoiceTypeDummyGroup();
      case QuestionType.InfoPage:
        return new FormControl('');
      case QuestionType.FileUpload:
        return new FormArray([]);
      case QuestionType.AIChat:
        return new FormArray([]);
      case QuestionType.NPS:
        return new FormControl('');
      case QuestionType.Ranking:
        return new FormControl('');
      default:
        return new FormControl('');
    }
  }

  private mapChoiceTypeDummyGroup(): FormGroup {
    const choicesGroup = new FormGroup({
      value: new FormControl(''),
      otherText: new FormControl('')
    });

    return choicesGroup;
  }

  private mapCarouselDummyControls(activeQuestion: Question): FormGroup {
    const carouselGroup = new FormGroup({});
    activeQuestion.cards.forEach((card) => {
      carouselGroup.addControl(card.id, this.mapChoiceTypeDummyGroup());
    });

    return carouselGroup;
  }
}
